import { createFileRoute } from '@tanstack/react-router';
import { requireSession } from '../../auth/require-session.js';
import { SessionError, SessionPending } from '../../auth/SessionStates.js';
import { CaptureClipboardPage } from '../../capture-clipboard/CaptureClipboardPage.js';

// Stage 2 (brief deliverable 6): guarded like every other authenticated route.
export const Route = createFileRoute('/capture-clipboard/')({
  beforeLoad: async ({ location }) => ({ me: await requireSession(location.pathname) }),
  pendingComponent: SessionPending,
  pendingMs: 0,
  pendingMinMs: 0,
  errorComponent: SessionError,
  component: CaptureClipboardPage,
});
